import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "./App.css";

import { AuthProvider } from "./HHC/components/Context/ContextAPI";
import { CallProvider } from "./HHC/components/Context/CallContext";

// ---------------------------------------------------------
// Global Fetch Interceptor
// ---------------------------------------------------------
const originalFetch = window.fetch;

window.fetch = async function (...args) {
  // Get the URL from the first argument (handles both fetch(url) and fetch(url, options))
  const url =
    typeof args[0] === "string"
      ? args[0]
      : args[0] && args[0].url
        ? args[0].url
        : "";

  try {
    const response = await originalFetch(...args);

    // 1. Define the API paths you want to IGNORE (e.g., the message count API)
    const IGNORED_ENDPOINTS = ["/web/all_msg_counts/"];

    // 2. Check if the current request URL is in the ignored list
    const isIgnored = IGNORED_ENDPOINTS.some((path) => url.includes(path));

    // 3. Logic: Only trigger session expiration if status is 401/403
    //    AND it is NOT one of the ignored endpoints.
    if ((response.status === 401 || response.status === 403) && !isIgnored) {
      console.warn(`Global ${response.status} Detected! Session Expired.`);
      localStorage.removeItem("token");
      window.dispatchEvent(new CustomEvent("session-expired"));
    }

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
// ---------------------------------------------------------

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    {/* 
      Provider is commented out based on your provided code.
      Uncomment it if you need Redux support.
    */}
    {/* 
    <Provider store={store}>
      <App />
    </Provider> 
    */}
    <AuthProvider>
      <CallProvider>
        <App />
      </CallProvider>
    </AuthProvider>
  </React.StrictMode>,
);

reportWebVitals();
